// Use hex codes only, not color names. The documentation uses the hex code to check ADA compliance
const colors = {
  primary: '#007AC5',
  primaryDark: '#005f9e',
  secondary: '#01C3BA',
  lightNeutral: '#D3D3D3',
  darkNeutral: '#808080',
  tertiary: '#F8A62D',
  light: '#FFFFFF',
  dark: '#000000',
  primaryGradient: 'linear-gradient(#007AC5, #007AC5 0%, #005F9E 100%)',
  primaryGradientHovered: 'linear-gradient(#005F9E, #005F9E 0%, #012135 100%)'
}

export default colors
